import { Typography, Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Paper from "@mui/material/Paper";
import ChangeIcon from 'src/components/ChangeIcon';
import axios from 'src/utils/axios';
import ExpandableComment from 'src/components/ExpandableComment';

const styles = {
  root: {},
  content: {
    padding: 0,
    minHeight: 430
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: (theme) => ({
    padding: theme.spacing(1)
  }),
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }),
  divider: {
    backgroundColor: '#1D3343'
  },
  secondaryTail: (theme) => ({
    backgroundColor: theme.palette.secondary.main
  })
};

function Tarihce({
  BasvuruId, OpenClose
}) {
  const [yorumData, setYorumData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getApolloYorum(BasvuruId);
  }, [BasvuruId]);

  const getApolloYorum = (BasvuruId) => {
    setLoading(true)
    if (!BasvuruId) {
      return;
    }
    axios.get("/GetApolloYorum/" + BasvuruId + "/" + OpenClose).then(response => {
      setYorumData(response.data)
      setLoading(false)
    });
  }

  return (
    <>
      <Backdrop sx={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Timeline position="alternate-reverse">
        {yorumData?.length > 0 && yorumData?.map((log, index) =>

          <TimelineItem key={index}>
            <TimelineSeparator>
              <TimelineDot color="inherit">
                <ChangeIcon MobilStatusId={Number(log.DURUM_ID)} />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Paper elevation={3} style={{ backgroundColor: '#e0e0e0', padding: "6px 16px" }} >
                <Typography variant="h6" component="h1"
                  sx={styles.inline}
                  color="textPrimary"
                > <h2><b> {log.BASVURU_ID + ' - ' + log.DURUM} </b></h2>
                </Typography>
                <Typography>
                  <b> KULLANICI ADI SOYADI:</b> {log.ADSOYAD}
                  <br></br>
                  <b> YORUM:</b> <ExpandableComment Comment={log.YORUM} CommentLimit={500} DarkColor={false} />
                  <br></br>
                  <b> TARIH:</b> {log.GUN + " " + log.AY + " " + log.YIL + " " + "-" + " " + log.SAAT}
                </Typography>
              </Paper>
            </TimelineContent>

          </TimelineItem>
        )}
      </Timeline>
    </>




  );
}


Tarihce.propTypes = {
  className: PropTypes.string
};

export default connect(
  // state => ({
  //   taskHistoryReducer: state.taskHistoryReducer
  // }),
  // { taskHistoryRequest }
)(Tarihce);
